import { storefrontRequestConfig } from './api.js'

export async function storefrontFetch (query, variables = {}) {
  const res = await fetch('/api/2025-07/graphql.json', {
    method: 'POST',
    headers: {
      ...storefrontRequestConfig.headers
    },
    body: JSON.stringify({ query, variables })
  })
  const json = await res.json()
  return json.data
}
